import { Component } from '@angular/core'

@Component({
  selector: 'app-tax-rules',
  imports: [],
  templateUrl: './tax-rules.component.html',
  styleUrl: './tax-rules.component.scss'
})
export class TaxRulesComponent {}
